import type { Appointments } from "@/lib/appointments"
import { Mirror } from "@/lib/mirror"

export const mergeAppointmentResults = ({
  appointmentResult,
  existingAppointmentResults = Mirror.build({}),
}: {
  appointmentResult: Appointments.AppointmentResult
  existingAppointmentResults?: Mirror<Appointments.AppointmentResult>
}): Mirror<Appointments.AppointmentResult> => {
  if (existingAppointmentResults.collection[appointmentResult.id]) {
    return existingAppointmentResults
  }

  return Mirror.build({
    ...existingAppointmentResults.collection,
    [appointmentResult.id]: appointmentResult,
  })
}
